import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    getExpensesByMemberNo,
    selectMemberExpenseByMemberNo
} from "../../../state/ducks/member/index";
import { createPayment, selectPayment, selectCurrentPage, changeCurrentPage, getActiveMemberNumber, getPaymentSum, selectPaymentSum, getActiveMemberNoList } from "../../../state/ducks/payment/index"
import $ from 'jquery';
import { createPaymentPages } from '../../../state/ducks/payment/types';
import { withRouter } from "react-router-dom";

const pageStatus = [createPaymentPages.orderDetail, createPaymentPages.creditCard, createPaymentPages.sms, createPaymentPages.done];

function formKontrol() {
    var paymentType = $("#paymentType").val();
    var durum = 1;
    if (paymentType == "0") {
        durum = 0;
        $("#paymentType").parent().addClass("t-error");
        $("#paymentType").next().html("<i class='t-icon-error text-danger'></i>");
        $("#paymentType_hatamesaj").html("Ödeme şekli boş bırakılamaz");
    } else {
        $("#paymentType").parent().removeClass("t-error");
        $("#paymentType").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
        $("#paymentType_hatamesaj").html("");
    }
    return durum;
}

export class CreatePayment extends Component {

    state = {
        paymentType: "0"
    }

    onSubmit = e => {
        e.preventDefault();


        const { dashboard } = this.props;

        if (formKontrol() == 0) {
            return false;
        }

        if (this.state.paymentType == "2") {
           
            if (dashboard?.installmentPaymentBankType == "1") {
                this.props.history.push({ pathname: "/Home/CreatePaymentOrderPayTr", state: { paymentType: 2 } });
            } else if (dashboard?.installmentPaymentBankType == "2") {
                this.props.history.push({ pathname: "/Home/CreatePaymentOrderEminPay", state: { paymentType: 2 } });
            }
        } else {
            if (dashboard?.oneShotPaymentBankType == "0") {
                this.props.history.push("/Home/CreatePaymentOrder");
            } else if (dashboard?.oneShotPaymentBankType == "1") {
                this.props.history.push("/Home/CreatePaymentOrderPayFor");
            } else if (dashboard?.oneShotPaymentBankType == "2") {

                this.props.history.push({ pathname: "/Home/CreatePaymentOrderPayTr", state: { paymentType: 1 } });
            }
            else if (dashboard?.oneShotPaymentBankType == "3") {
                this.props.history.push({ pathname: "/Home/CreatePaymentOrderEminPay", state: { paymentType: 1 } });
            }
            
        }
    }

    render() {
        return (
            <>

                {/* yesil Alan*/}
                <div className="row" style={{ padding: "3%" }}>
                    <div className="col-12">
                        {/* KUTU 1 */}
                        <div className="row no-gutters t-kutu t-yesilCizgi">
                            <div
                                className="col bosluk backtop"
                                style={{
                                    backgroundImage: 'url("/assets/img/backgrounds/back_top_yesil.jpg")'
                                }}
                            >
                                {/* içerikler */}
                                {/* Başlık */}
                                <div className="row no-gutters pb-4">
                                    <div clss="col-auto">
                                        <i className="t-icon-wallet  icon" />
                                    </div>
                                    <div className="col d-flex flex-column justify-content-center">
                                        <div className="baslik" style={{ padding: "0 0 5px 0" }}>
                                            Ödeme Talimatı
                                        </div>
                                        <span className="altBaslik">Ödeme Talimatı Verme</span>
                                    </div>
                                </div>
                                <div className="row no-gutters ">


                                    {/* Ödeme Şekli*/}
                                    <div className="col-12 pb-1">
                                        <span className="t-icInputTitle pl-3">Ödeme Şekli</span>
                                    </div>
                                    <div className="col-12">
                                        <div className="t-icInput">
                                            <div>
                                                <i className="t-icon-credit_card" />
                                            </div>
                                            <select className="custom-select" id="paymentType"
                                                onChange={(e) => {
                                                    this.setState({ paymentType: e.target.value });
                                                }}
                                            >
                                                <option value="0">Seçiniz</option>
                                                <option value="1">Tek Çekim</option>
                                                <option value="2">Taksitli</option>
                                            </select>
                                            <div />
                                        </div>
                                    </div>
                                    {/* Hata mesajının geleceği alan*/}
                                    <div
                                        className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                                        id="paymentType_hatamesaj"
                                    />

                                    {/* Button */}
                                    <div className="col-12 d-flex justify-content-center pb-3">
                                        <button className="t-icButtonYesil" onClick={this.onSubmit}>
                                            <span>Devam</span>
                                            <i className="t-icon-arrow-right2" />
                                        </button>
                                    </div>
                                </div>
                                <div className="row no-gutters pt-4 justify-content-center align-items-start">
                                    {/* cizgi*/}
                                    <div className="col-1 t-cizgiBackgroundKenar" />
                                    {/* 1*/}
                                    <div className="col-auto t-icStepAktif">
                                        <div className="ortala">
                                            <div className="yuvarlak">1</div>
                                        </div>
                                        <span>Ödeme Bilgileri</span>
                                    </div>
                                    {/* cizgi*/}
                                    <div className="col-auto t-cizgiBackgroundOrta" />
                                    {/* 2*/}
                                    <div className="col-auto t-icStepPasif">
                                        <div className="ortala">
                                            <div className="yuvarlak">2</div>
                                        </div>
                                        <span>Kart Bilgileri</span>
                                    </div>
                                    {/* cizgi*/}
                                    <div className="col-auto t-cizgiBackgroundOrta" />
                                    {/* 2*/}
                                    <div className="col-auto t-icStepPasif">
                                        <div className="ortala">
                                            <div className="yuvarlak">3</div>
                                        </div>
                                        <span>Onay</span>
                                    </div>
                                    {/* cizgi*/}
                                    <div className="col-1 t-cizgiBackgroundKenar" />
                                </div>
                                {/* içerikler BİTTİ */}
                            </div>
                            <div className="col-auto renk" />
                        </div>
                        {/* KUTU 1 BİTTİ */}
                    </div>
                </div>

            </>
        )
    }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = dispatch => ({

});
export default connect(mapStateToProps, mapDispatchToProps)(CreatePayment);